import { useEffect, useState } from "react";
import GenericMazeActivity from "./Mazes";

export default function Level6_Mazes(props) {
  return (
    <GenericMazeActivity
      open={props.open}
      openActivity={props.openActivity}
      changePdf={props.changePdf}
      config={{
        showLanding: true,
        mode: "type-progressions",  //
        basePath: "/VisuallyDirectedFineMotor/Mazes",
        defaultLevel: "Level1",
        options: {
          types: [
            { id: "Level1", label: "Collect the coins", defaultMaze: "1" },
            { id: "Level2", label: "Enter if you dare", defaultMaze: "1" },
            { id: "Level3", label: "Escape if you can", defaultMaze: "1" },
            { id: "Level4", label: "Wombat den", defaultMaze: "1" },
          ],
          progressions: [
            { id: "1", label: "Level 1: Ensnare" },
            { id: "2", label: "Level 2: Mystify" },
            { id: "3", label: "Level 3: Disorient" },
          ],
        },
      }}
    />
  );
}